import { render, staticRenderFns } from "./contactus.vue?vue&type=template&id=38c3e064&scoped=true"
import script from "./contactus.vue?vue&type=script&lang=js"
export * from "./contactus.vue?vue&type=script&lang=js"
import style0 from "./contactus.vue?vue&type=style&index=0&id=38c3e064&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c3e064",
  null
  
)

export default component.exports